import React, { FC } from 'react'

import { Box, Pill, Text } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import FrontOfSectionIcon from '@/design-system/custom-icons/components/front-of-section-icon'
import { useFrontOfSectionBadgeFeature } from '@/optimizely/features/front-of-section-badge'
import { BadgeCategories, BadgeTitles, ListingBadge } from '@/types/app-types'

import styles from './styles.module.scss'

interface ListingBadgesProps {
    badge?: ListingBadge
}

const ListingBadges: FC<ListingBadgesProps> = ({ badge }) => {
    const [isFrontOfSectionBadgeFeatureEnabled] = useFrontOfSectionBadgeFeature()
    const isFrontOfSectionBadge = badge?.title === BadgeTitles.FrontOfSection

    if (isFrontOfSectionBadgeFeatureEnabled && isFrontOfSectionBadge) {
        return (
            <Box display="flex" className={styles.frontOfSectionBadge}>
                <Pill importance="none" className={styles.frontOfSectionPill}>
                    <FrontOfSectionIcon />
                    <Text size="sm" as="div" weight="regular" data-testid={`badge-${badge?.category}`} altFont>
                        {badge.title}
                    </Text>
                </Pill>
            </Box>
        )
    }

    if (!isFrontOfSectionBadge) {
        const badgeStyles = classNames({
            [styles.priceBadge]: badge?.category === BadgeCategories.Price,
            [styles.scarcityBadge]: badge?.category === BadgeCategories.Scarcity,
            [styles.urgencyBadge]: badge?.category === BadgeCategories.Urgency,
        })

        return (
            <Box display="flex">
                <Text
                    size="sm"
                    as="div"
                    weight="regular-bold"
                    data-testid={`badge-${badge?.category}`}
                    className={badgeStyles}
                    altFont
                >
                    {badge?.title}
                </Text>
            </Box>
        )
    }

    return null
}

export default ListingBadges
